import { render, staticRenderFns } from "./ShippingStatisticChart.vue?vue&type=template&id=30e42f18&"
import script from "./ShippingStatisticChart.vue?vue&type=script&lang=js&"
export * from "./ShippingStatisticChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports